import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Rack extends CRUDService {
  constructor() {
    super(APIPath.racks);
  }

  types() {
    return BaseService.get(APIPath.rackTypes);
  }

  presets() {
    return BaseService.get(APIPath.rackPresets);
  }

  addLocations(data) {
    return BaseService.post(APIPath.rackLocations, data);
  }

  verifyLocation(code, params) {
    const url = `${
      APIPath.racksLocationValidate
    }/${code}/?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }
}

const RackService = new Rack();
Object.freeze(RackService);
export { RackService };
